import { useGlobals } from 'hooks/useGlobals';
import { useIsSkincare } from 'hooks/useIsSkincare';
import { SCIENCE, SKINCARE_SCIENCE } from 'lib/constants/routes';
import { SciencePageId } from 'types/cms/science/SciencePageId';

import { ResultLayout } from '../layouts/ResultLayout';
import type { NavigationPayload } from '../SearchResults';

interface ScienceProps {
  onNavigate: ({ title, path }: NavigationPayload) => void;
}

const supplementsTitle = 'Why Mitopure®';
const skincareTitle = 'Mitopure® for Skin Longevity';

export function Science({ onNavigate }: ScienceProps) {
  const isSkincare = useIsSkincare();
  const { data: globals } = useGlobals();
  const path = isSkincare ? SKINCARE_SCIENCE : SCIENCE;
  const title = isSkincare ? skincareTitle : supplementsTitle;

  const navigationCards = globals?.siteSettings.scienceNav?.navigationCards;
  const scienceCard = navigationCards?.find(
    (card) => card.link._id === SciencePageId.SCIENCE,
  );

  return (
    <ResultLayout
      href={path}
      title={title}
      image={scienceCard?.image}
      onNavigate={() => onNavigate({ title, path })}
      type="Science"
    />
  );
}
